import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import { IInboundItemIdentifier } from 'commons/types';
import { bulkCheckInboundTaskItemAction } from 'redux-stores/actions';

import { IRowMenuItemData } from '../interfaces';

export const RowMenuItemConfig: Record<string, IRowMenuItemData> = {
  Approve: {
    title: 'Approve',
    content: (skuCodes: string[]): string => {
      return `Are you sure to approve following SKUs: \n\n ${skuCodes.join(
        '\n',
      )}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      inboundTaskNumber: string,
      invoiceNumber: string,
      items: IInboundItemIdentifier[],
    ): void => {
      dispatch(
        bulkCheckInboundTaskItemAction({
          inbound_task_number: inboundTaskNumber,
          invoice_number: invoiceNumber,
          items,
          approved: true,
        }),
      );
    },
  },
  Reject: {
    title: 'Reject',
    content: (skuCodes: string[]): string => {
      return `Are you sure to reject following SKUs: \n\n ${skuCodes.join(
        '\n',
      )}?`;
    },
    onConfirm: (
      dispatch: ThunkDispatch<unknown, unknown, UnknownAction>,
      inboundTaskNumber: string,
      invoiceNumber: string,
      items: IInboundItemIdentifier[],
    ): void => {
      dispatch(
        bulkCheckInboundTaskItemAction({
          inbound_task_number: inboundTaskNumber,
          invoice_number: invoiceNumber,
          items,
          approved: false,
        }),
      );
    },
  },
};
